var map = {
	"./404.png": "3452",
	"./505Vector.png": "8b46",
	"./accessDenied.png": "1214",
	"./account-circle.png": "ef0e",
	"./account-multiple-outline.png": "702c",
	"./accountgroupoutline.png": "db75",
	"./applicationexport.png": "7941",
	"./archive.png": "a065",
	"./cash.png": "978d",
	"./chart-line.png": "0108",
	"./chaticon.png": "3ff3",
	"./checkIcon.png": "7b45",
	"./chevron-down.svg": "dd40",
	"./chevronDown.png": "128b",
	"./clubIcon.png": "7ff3",
	"./coffeCup.png": "50a1",
	"./cog.png": "fef4",
	"./comment.png": "7495",
	"./copy.png": "4b89",
	"./dashboard.png": "0316",
	"./dashboardAdd.png": "eed2",
	"./dataBaseError.png": "521e",
	"./disableStar.png": "3cdb",
	"./email.png": "aef1",
	"./enableStar.png": "a338",
	"./file-document-edit.png": "9053",
	"./file-document.png": "df43",
	"./git.png": "66e2",
	"./help-circle.png": "7ad4",
	"./invoices.png": "f168",
	"./lifebuoy.png": "d02c",
	"./link.png": "17ab",
	"./menuIcon.png": "5cbf",
	"./newUsers.png": "ecbe",
	"./order.png": "87aa",
	"./paymentIcon.png": "3183",
	"./pencil-edit.png": "99524",
	"./receipttext.png": "bc16",
	"./sms-cup.png": "046c",
	"./sms.png": "5e8d",
	"./text-box-multiple.png": "0c5e",
	"./total.png": "9351",
	"./videoGuide.png": "835f",
	"./voucher.png": "bb2a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";